module.exports = __webpack_public_path__ + "static/media/drive.0d0a4efa.png";